var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "命中查询",
            visible: _vm.dialogVisible,
            "before-close": _vm.hide,
            width: "50%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "query-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "展示页面", prop: "displayPage" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "请选择展示页面",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.displayPage,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "displayPage", $$v)
                        },
                        expression: "form.displayPage",
                      },
                    },
                    _vm._l(_vm.displayPage, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "渠道", prop: "channelId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        filterable: "",
                        "filter-method": _vm.dataFilter,
                        clearable: "",
                        placeholder: "请选择渠道",
                      },
                      on: {
                        change: _vm.handleChannelChange,
                        "visible-change": _vm.handleVisibleChange,
                      },
                      model: {
                        value: _vm.form.channelId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelId", $$v)
                        },
                        expression: "form.channelId",
                      },
                    },
                    _vm._l(_vm.channelShowOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: _vm.getChannelLabel(item),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "400px" },
                  attrs: { label: "应用版本号", prop: "appVersion" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入版本号, 正整数",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.appVersion,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "appVersion", $$v)
                      },
                      expression: "form.appVersion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "300px" },
                  attrs: { label: "协议版本号", prop: "protocolVersion" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "请选择协议版本号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.protocolVersion,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "protocolVersion", $$v)
                        },
                        expression: "form.protocolVersion",
                      },
                    },
                    _vm._l(_vm.protocolVersionOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "400px" },
                  attrs: { label: "手机厂商", prop: "phoneBrand" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机厂商", clearable: "" },
                    model: {
                      value: _vm.form.phoneBrand,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phoneBrand", $$v)
                      },
                      expression: "form.phoneBrand",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "400px" },
                  attrs: { label: "设备UID", prop: "deviceUid" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入设备UID", clearable: "" },
                    model: {
                      value: _vm.form.deviceUid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "deviceUid", $$v)
                      },
                      expression: "form.deviceUid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "query-btn-box" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.query },
                },
                [_vm._v(" 发起查询 ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "result" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "result-content",
              },
              [
                _vm.result
                  ? [
                      _vm.isVideoPageCard
                        ? _c("div", [
                            _c("div", { staticClass: "config-section" }, [
                              _c("strong", [_vm._v("置顶卡片配置：")]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    JSON.stringify(_vm.topCardConfig, null, 2)
                                  )
                                ),
                              ]),
                              _c("br"),
                            ]),
                            _c("div", { staticClass: "config-section" }, [
                              _c("strong", [_vm._v("非置顶卡片配置：")]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    JSON.stringify(
                                      _vm.regularCardConfig,
                                      null,
                                      2
                                    )
                                  )
                                ),
                              ]),
                              _c("br"),
                            ]),
                          ])
                        : _vm.isNoVideoPageCard
                        ? _c("div", { staticClass: "config-section" }, [
                            _c("strong", [_vm._v("卡片配置：")]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  JSON.stringify(_vm.regularCardConfig, null, 2)
                                )
                              ),
                            ]),
                            _c("br"),
                          ])
                        : _vm._e(),
                      _vm.appScreenConfigRes
                        ? _c("div", { staticClass: "config-section" }, [
                            _c("strong", [_vm._v("投屏功能配置：")]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  JSON.stringify(
                                    _vm.appScreenConfigRes,
                                    null,
                                    2
                                  )
                                )
                              ),
                            ]),
                            _c("br"),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }